<template>
  <div
    class="w-full footer-bg-color footer-text-color mt-20"
    :style="[customCss]"
  >
    <div class="membership-layout-container">
      <div class="flex sm:flex-row flex-col justify-between items-center py-5 footer-menu">
        <slot name="logo"></slot>
        <div class="flex sm:flex-row flex-col text-base sm:space-x-6 capitalize">
        <slot name="menus"></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Footer',
  props: {
    getThemeSettings: {
      type: Function,
      required: true,
    },
  },
  computed: {
    customCss() {
      return {
        '--template-footer-bg-color':
          this.themeSettings.footer_section.bg_color,
        '--template-footer-text-color':
          this.themeSettings.footer_section.text_color,
      };
    },
    themeSettings() {
      return this.getThemeSettings();
    },
  },
};
</script>
<style lang="scss" scoped>
.footer-bg-color {
  background-color: var(--template-footer-bg-color);
}
.footer-text-color {
  color: var(--template-footer-text-color);
}
</style>
